import { Box, Grid, Stack, Typography } from '@mui/material'
import CardTitle from './cardTitle';
import ClickableCard from '../../common/clickableCard';
import SkeletonCard from '../../common/skeletonCard';
import TouBars from '../../common/touBars';
import custom from '../../../styles/mui/szVariables.json'

export default function TouGridUsageCard({ 
        id, color, content, handleCardClick }: any) {

    if(!content) return (
        <SkeletonCard height="142px" />
    )
    return (
        <ClickableCard
            id={id}
            height="142px"
            px={custom.spacing.sm}
            py={custom.spacing.sm}
            handleCardClick={ ()=>handleCardClick(true)}>
             <Grid container direction="column" 
                    justifyContent="flex-end">
                <Grid item>
                    <CardTitle icon={content.icon} 
                                cardTitle={content.cardTitle}
                                hoverIcon={content.hoverIcon} 
                                id={id} />
                </Grid>
                <Grid item width="100%" 
                    mt={custom.spacing.md}>
                    <Typography variant='szHeading.Bold.Medium' 
                        id='netValue' >
                        {content.netKw}
                        <Typography
                            variant="szHeading.Regular.Small" >
                            {content.unit}
                        </Typography>
                    </Typography>
                    <Typography id="description"
                        display={{xs:'inline-block',sm:'none',md:'none',lg:'none'}}
                        sx={{ ml:1, color: 'text.primary'}}
                        noWrap
                        variant="szBody.Regular.xSmall" >
                        {content.desc}
                    </Typography>
                </Grid>
                <Grid item width="100%">
                    <Grid container direction="row" 
                        justifyContent="flex-start" 
                        alignItems="flex-left" display="flex">
                        <Grid item xs={3} sm={3} md={3} lg={3}
                            display={{xs:'none',sm:'flex',md:'flex',lg:'flex'}}
                            >
                            <Typography component="p" id="description"
                                sx={{ color: 'text.primary'}}
                                noWrap
                                variant="szBody.Regular.xSmall" >
                                {content.desc}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={9} md={9} lg={9} 
                            alignContent={"center"}>
                            <Stack direction="row" 
                                alignItems={"center"}
                                justifyContent={{
                                    xs:"flex-start",
                                    sm:"flex-end",
                                    md:"flex-end",
                                    lg:"flex-end"
                                }} width="100%">
                                <Box height="12px" width="12px" 
                                    sx={{ 
                                        backgroundColor: 'sz.colors.orange200',
                                        borderRadius: custom.corners2,
                                        mr: custom.spacing.xxxs,
                                        display: 'inline-block'
                                    }}/> 
                                <Typography variant='szBody.Regular.xSmall' 
                                    id='offPeakText' 
                                    pr={custom.spacing.xxxs} noWrap>   
                                    Off-peak
                                </Typography>
                                <Typography variant='szBody.Bold.xSmall' 
                                    id='offPeakValue' >
                                    {content.offPeak}%
                                </Typography>
                                <Box height="12px" width="12px" sx={{ 
                                        backgroundColor: 'sz.colors.orange300',
                                        mx: custom.spacing.xxxs,
                                        borderRadius: custom.corners2,
                                        display: 'inline-block'
                                    }}/> 
                                <Typography variant='szBody.Regular.xSmall' 
                                    id='shoulderText' 
                                    pr={custom.spacing.xxxs}>   
                                    Shoulder
                                </Typography>
                                <Typography variant='szBody.Bold.xSmall' 
                                    id='shoulderValue' >
                                    {content.shoulder}%
                                </Typography>
                                <Box height="12px" width="12px" sx={{ 
                                        backgroundColor: 'sz.colors.orange400',
                                        mx: custom.spacing.xxxs,
                                        borderRadius: custom.corners2,
                                        display: 'inline-block'
                                    }}/> 
                                <Typography variant='szBody.Regular.xSmall' 
                                    id='peakText' 
                                    pr={custom.spacing.xxxs}>   
                                    Peak
                                </Typography>
                                <Typography variant='szBody.Bold.xSmall' 
                                    id='peakValue' >
                                    {content.peak}%
                                </Typography>

                            </Stack>
                        </Grid>
                        <Grid item xs={12} py={custom.spacing.xxs}>
                            <TouBars content={content} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>  
        </ClickableCard>
    )
}